module.exports = __webpack_public_path__ + "static/author-2-36682b2149be694f4a2ab3a1e76cf3c7.jpg";